import { render, staticRenderFns } from "./ShareOfShelf.vue?vue&type=template&id=83810b84&scoped=true"
import script from "./ShareOfShelf.vue?vue&type=script&lang=js"
export * from "./ShareOfShelf.vue?vue&type=script&lang=js"
import style0 from "./ShareOfShelf.vue?vue&type=style&index=0&id=83810b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83810b84",
  null
  
)

export default component.exports